import EventEmitter from "../state/EventEmitter";
import {
  IDialogBoxYesNoEvent,
  IDialogBoxEvent,
  IDialogBoxConfirmEvent,
  IDialogBoxWaitingEvent,
} from "../types/DialogBoxEvents";
import DialogBox from "../components/DialogBox";

import "../styles/dialogBoxHandler.css";
import SubscribingComponent from "./SubscribingComponent";
import { flushSync } from "react-dom";

export default class DialogBoxHandler extends SubscribingComponent<
  {},
  {
    id: number;
    message?: string;
    header?: string;
    labels?: { yes: string; no: string };
  }
> {
  queuedQueries: IDialogBoxEvent[] = [];
  currentQuery?: IDialogBoxEvent | null;
  checkMessageTimerId: NodeJS.Timeout | null = null;
  constructor(props: Readonly<{}>) {
    super(props);
    this.state = {
      id: Math.random(),
      message: "",
      header: "Confirm", // change to be Dialog Box Event specific
      labels: { yes: "Yes", no: "No" },
    };
  }

  setStateSync: typeof this.setState = (...args) => {
    flushSync(() => {
      this.setState(...args);
    });
  };

  componentDidMount() {
    this.subscribe("DB_kill_open", () => {
      this.currentQuery = null;
      this.forceUpdate();
    });
    this.subscribe("DB_yesNoQuery", (event: IDialogBoxYesNoEvent) => {
      this.queuedQueries.push(event);
    });
    this.subscribe("DB_confirm", (event: IDialogBoxConfirmEvent) => {
      this.queuedQueries.push(event);
    });

    this.subscribe("DB_waiting", (event: IDialogBoxWaitingEvent) => {
      this.queuedQueries.push(event);
    });

    this.checkMessageTimerId = setInterval(() => this.checkForNewEvents(), 0);
  }

  checkForNewEvents() {
    if (this.currentQuery == null && this.queuedQueries.length > 0) {
      this.currentQuery = this.queuedQueries.pop();
      this.setStateSync({
        id: Math.random(),
        message: this.currentQuery?.message,
        header: this.currentQuery?.header,
        labels: this.currentQuery?.labels,
      });
    }
  }

  async yesNo(yes: boolean) {
    if (this.currentQuery == null) return;
    const query: IDialogBoxYesNoEvent = this.currentQuery;
    this.currentQuery = null;
    this.setStateSync({
      id: Math.random(),
      message: "",
    });
    query.callback(yes);
  }

  render() {
    if (this.currentQuery == null || this.state.message === "") return <> </>;
    return (
      <div className={"dialogBox-background"}>
        <DialogBox
          rawEvent={this.currentQuery}
          type={this.currentQuery.type}
          header={this.state.header}
          labels={this.state.labels}
          message={this.state.message}
          onClick={(yes: boolean) => this.yesNo(yes)}
        />
      </div>
    );
  }
}
